import Link from '@mui/material/Link';
import ImageHolder from './Image';

import type {LinkProps} from '@mui/material/Link';
import type {Props as ImageProps} from './Image';

export interface Props extends ImageProps {
  linkProps?: LinkProps;
}

const ImageWithLink = (props: Props) => {
  const {linkProps, ...prop} = props || {};
  return (
    <Link {...linkProps}>
      <ImageHolder {...prop} />
    </Link>
  );
};

export default ImageWithLink;
